
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (this.notification) {
      this.notification.addEventListener('keyup', (evt) => {
        if (evt.code === 'Escape') this.close();
      });
    }

    this.querySelectorAll('button[type="button"]').forEach((button) => {
      button.addEventListener('click', this.close.bind(this));
    });
  }

  open() {
    if (!this.notification) return;

    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  async renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    // Keep Dawn's standard cart notification updates.
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      const sectionHTML = parsedState.sections?.[section.id];

      if (!element || !sectionHTML) return;

      try {
        element.innerHTML = this.getSectionInnerHTML(
          sectionHTML,
          section.selector
        );
      } catch (error) {
        console.error(
          `Could not refresh section: ${section.id}`,
          error
        );
      }
    });

    // Fetch a freshly rendered progress bar from the cart page.
    await this.refreshProgressBar();

    if (this.header) this.header.reveal();
    this.open();
  }

  async refreshProgressBar() {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const cartUrl = `${root}cart?sections=main-cart-footer`;

      const response = await fetch(cartUrl, {
        headers: {
          Accept: 'application/json',
        },
        cache: 'no-store',
      });

      if (!response.ok) {
        throw new Error('Unable to refresh the cart progress bar.');
      }

      const sections = await response.json();
      const footerHTML = sections['main-cart-footer'];

      if (!footerHTML) {
        console.warn(
          'The main-cart-footer section was not returned. Check its Shopify section ID.'
        );
        return;
      }

      const parsedHTML = new DOMParser().parseFromString(
        footerHTML,
        'text/html'
      );

      const freshProgress = parsedHTML.querySelector(
        '.jh-cart-progress'
      );

      const currentProgress = document.querySelector(
        '#cart-notification .jh-cart-progress'
      );

      if (freshProgress && currentProgress) {
        currentProgress.replaceWith(freshProgress);
      } else {
        console.warn(
          'Could not find the progress bar in the refreshed cart HTML.'
        );
      }
    } catch (error) {
      console.error('Progress bar refresh failed:', error);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHTML = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const element = parsedHTML.querySelector(selector);

    if (!element) {
      throw new Error(`Could not find section selector: ${selector}`);
    }

    return element.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (
      target !== this.notification &&
      !target.closest('cart-notification')
    ) {
      const disclosure = target.closest(
        'details-disclosure, header-menu'
      );

      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : null;

      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}
